<template>
  <div class="nova-consulta" :style="'--cor-primaria:' + corPrimaria + '0A; --cor-primaria-02:' + corPrimaria + '2A'">
    <h3 class="nova-consulta-title align">{{funcionalidade.parametros.textos.tituloTelaNovaConsulta}}</h3>
    <el-card v-if="(ativaAgendamentoTeleconsulta && permiteAgendarTeleconsulta) || (ativaAgendamentoPresencial && permiteAgendarPresencial)" style="height: 212px;" class="card" shadow="never">
      <h3 class="nova-consulta-title center">Agende uma consulta</h3>
      <span class="tiny-text">Escolha o melhor dia e horário para você.
              As consultas agendadas podem ser presenciais ou por video (teleconsulta).
            </span>
      <div style="padding-top:10px">
        <el-button @click="nextRoutePresencial()"
                   :style="`background-color: ${corBtnPrincipal}`"
                   v-if="ativaAgendamentoPresencial && permiteAgendarPresencial"
                   class="btn-card margin-btn-2">
          <inline-svg height="15" fill="#FFFFFF" class="svg-btn" :src="require('@/assets/icons/Icon_schedule_calendar.svg')"></inline-svg>
          <span class="text-btn-primary">Consulta Presencial</span>
        </el-button>
        <el-button @click="nextRouteVideo()"
                   v-if="ativaAgendamentoTeleconsulta && permiteAgendarTeleconsulta"
                   :style="`background-color: ${corBtnPrincipal}`"
                   class="btn-card margin-btn-2-2">
          <inline-svg height="15" fill="#FFFFFF" class="svg-btn" :src="require('@/assets/icons/Icon_schedule_calendar.svg')"></inline-svg>
         <span class="text-btn-primary">Consulta por Vídeo</span>
        </el-button>
      </div>
      <inline-svg class="img-card-left" :fill="`${corPrimaria}4A`" height="60" :src="require('@/assets/img/img_consulta_agendar.svg')"></inline-svg>
    </el-card>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import inlineSvg from 'vue-inline-svg'
export default {
  components: {
    inlineSvg
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('SetupApp', ['estilo']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    idTermoUsoPresencial () {
      return this.funcionalidade.parametros.idTermoUsoConsultaPresencial
    },
    falecomMedico () {
      return this.funcionalidade.parametros.ativaFaleComMedico
    },
    corBtnPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBtnPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    ativaAgendamentoPresencial () {
      return this.funcionalidade.parametros.ativaAgendamentoConsultaPresencial
    },
    ativaAgendamentoTeleconsulta () {
      return this.funcionalidade.parametros.ativaAgendamentoTeleconsulta
    },
    ordem () {
      return this.funcionalidade.parametros.ordemLocalEspecialidades
    },
    permiteAgendarTeleconsulta () {
      return this.$route.query.permiteAgendarTeleconsulta === 'true'
    },
    permiteAgendarPresencial () {
      return this.$route.query.permiteAgendarPresencial === 'true'
    }
  },
  methods: {
    ...mapActions('Func53', ['setIdAgenda', 'setIdEpecialidade', 'setNomePrestador', 'setIdLocal', 'setTipoServico', 'setIdServico', 'setLocalAtendimento']),
    ...mapActions('BreadCrumbsStore', ['updateIten', 'orderItens']),
    ...mapMutations('BreadCrumbsStore', ['SET_CURRENT_STEP']),
    nextRoutePresencial () {
      const payload = { step: 0, value: 'Consulta Presencial' }
      this.updateIten(payload)
      this.setIdAgenda('1')
      this.$router.push({ path: '/53/TermosDeUso/', query: { id: `${this.idTermoUsoPresencial}` } })
    },
    nextRouteVideo () {
      this.setIdAgenda('2')
      const payload = { step: 0, value: 'Teleconsulta' }
      this.updateIten(payload)
      this.$router.replace({ query: { step: 2 } })
    }
  },
  created () {
    // Limpa todos os dados selecionados anteriormente
    this.setIdEpecialidade(null)
    this.setNomePrestador(null)
    this.setIdLocal(null)
    this.setLocalAtendimento(null)
    this.setTipoServico(null)
    this.setIdServico(null)
    this.SET_CURRENT_STEP(0)
  }
}
</script>
<style lang="less">
#func-53 {
  .backsvg {
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 80px;
  }
  .card {
    background-color: var(--cor-primaria);
    border: 1px solid;
    border-color: var(--cor-primaria-02);
    border-radius: 10px;
    width: 495px;
    box-shadow: none;
  }
  .svg-btn {
    margin-right: 5px;
    position: relative;
    top: 2px;
  }
  .nova-consulta-title {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
  }

  .align {
    padding: 30px 0 20px 0px;
  }

  .center {
    text-align: center;
    margin-bottom: 10px;
    margin-top: 5px;
  }
  .nova-consulta {
    padding: 0 20px;
  }
  .tiny-text {
    font-size: 12px;
    line-height: 17px;
    display: block;
    text-align: center;
    color: #333333;
  }

  .btn-card {
    border-radius: 18px;
    color: #FFFFFF;
    padding: 9px 0;
    width: 295px;
  }
  .margin-btn-1 {
    margin-top: 20px;
    margin-bottom: 5px;
    margin-left: 90px;
  }
  .margin-btn-2 {
    margin-bottom: 10px;
    margin-left: 90px;
  }
  .margin-btn-2-2 {
    margin-left: 90px;
    margin-bottom: 10px;
  }
  .img-card-right {
    float: right;
    position: relative;
    top: 9px;
    left: 12px;
  }
  .img-card-left {
    position: relative;
    right: 21px;
    bottom: 3px;
    top: -40px;
  }
}
</style>
